import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../core/upgraded-providers';
import { AlertService } from '../../ui.module';
import { CreepsService } from '../creeps.service';

const { OFFER_POWER_LEVEL_PROMO_END_TIME } = window.CONFIG;
const MSG_GPL_TOO_BIG = 'Your Global Power Level is greater than or equal to 3. \
Looks like you have everything set up already to create your first Power Creep!';
const MSG_NO_POWER_SPAWNS = 'You don\'t have a Power Spawn in the world. \
Please build this structure first and come back to this page again.';

@Component({
    selector: 'app-power-creeps-available',
    templateUrl: './power-creeps-available.component.pug',
    styleUrls: ['./power-creeps-available.component.less']
})
export class PowerCreepsAvailableComponent implements OnInit {

    public offerPromoEndTime = OFFER_POWER_LEVEL_PROMO_END_TIME;

    constructor (
        private _authService: AuthService,
        private _creepsService: CreepsService,
        private _alert: AlertService
    ) {
    }

    ngOnInit() {
    }

    public async onPromo(next) {
        try {
            await this._creepsService.promo();
            await this._authService.check();

            this.showSuccessDialog()
                .then(() => location.hash = '#!/overview/power');
        } catch (err) {
            if (err === 'GPL too big') {
                this.showAlertDialog(MSG_GPL_TOO_BIG);
            }

            if (err === 'no power spawns') {
                this.showAlertDialog(MSG_NO_POWER_SPAWNS);
            }
        }

        next();
    }

    private showSuccessDialog() {
        return this._alert.show({ data: {
            message: 'Your Global Power Level has been upgraded!',
            buttonOkLabel: 'Manage Power Creeps',
            icon: 'app2/assets/order/token-accept.svg'
        }});
      }

    private showAlertDialog(message) {
        return this._alert.show({ data: {
            message
        }});
    }
}
